import * as React from 'react';
import { useParams } from 'react-router-dom';
import { SeparationDetail } from './components/SeparationDetail';

/** `/separations/:id` — detalle de una separación propia (asesor). */
export function MySeparationDetailPage(): React.JSX.Element {
  const { id = '' } = useParams<{ id: string }>();
  return <SeparationDetail separacionId={id} alcance="propias" />;
}

/** `/admin/separations/:id` — detalle administrativo (alcance por permiso, ADR-014). */
export function AdminSeparationDetailPage(): React.JSX.Element {
  const { id = '' } = useParams<{ id: string }>();
  return <SeparationDetail separacionId={id} alcance="admin" />;
}
